<template>
  <div id="merchandises" style="background-color: white">

    <div  class="content"   style="margin-bottom: 2rem;background-color: white">
      <div class="page-detail"  >
        <div class="content-block" >
          <div  style="margin-bottom:2rem;margin-top: 0.6rem ">
            <div  style="font-weight: bold;text-align: center;color: #00469A;
    font-size: 1.2rem;" >定制商品详情</div>
          </div>
          <hr />
          <div>
            <div  class="list-block" id="tab-detail" style="margin-top: 0rem;" >
              <div v-if=" productName!== ''">
                <span style="color: #00469A">商品名称</span>
                <span style="WORD-BREAK: break-all; WORD-WRAP: break-word" >{{productName}}</span>
                <div style="margin-top: 1rem"><hr style=" height:0.06rem;
    border:0.06rem;
    background-color:#B4B4B4;"></div>
              </div>
              <div v-for="merchandise in attributeList" style="margin-bottom: 0.3rem;margin-top: 1.2rem;margin-left: 0.2rem;margin-right: 0.2rem" >
                <div v-if="merchandise.valueText && merchandise.valueText !== '-1' ">
                  <div v-if="merchandise.valueText.length>45">
                    <span style="color: #00469A">{{merchandise.label}}</span>
                    <span style="float: right;width: 9rem;">{{merchandise.valueText}}</span>

                    <div style="margin-top: 3.8rem"><hr style=" height:0.06rem;
    border:0.06rem;
    background-color:#B4B4B4;"></div>
                  </div>
                  <div v-if="merchandise.valueText.length>30 && merchandise.valueText.length<=45">
                    <span style="color: #00469A">{{merchandise.label}}</span>
                    <span style="float: right;width: 9rem;">{{merchandise.valueText}}</span>

                    <div style="margin-top: 2.5rem"><hr style=" height:0.06rem;
    border:0.06rem;
    background-color:#B4B4B4;"></div>
                  </div>
                  <div v-if="merchandise.valueText.length>14 && merchandise.valueText.length<=30">
                    <span style="color: #00469A">{{merchandise.label}}</span>
                    <span style="float: right;width: 9rem;">{{merchandise.valueText}}</span>

                    <div style="margin-top: 2.5rem"><hr style=" height:0.06rem;
    border:0.06rem;
    background-color:#B4B4B4;"></div>
                  </div>
                  <div v-if="merchandise.valueText.length<=14 ">
                    <span style="color: #00469A">{{merchandise.label}}</span>
                    <span style="float: right;">{{merchandise.valueText}}</span>

                    <div style="margin-top: 1rem"><hr style=" height:0.06rem;
    border:0.06rem;
    background-color:#B4B4B4;"></div>
                  </div>
                </div>
              </div>
              <div>
                <span style="color: #00469A">周期</span>
                <span style="float: right;">{{workdays}}</span>
                <div style="margin-top: 1rem"><hr style=" height:0.06rem;
    border:0.06rem;
    background-color:#B4B4B4;"></div>
              </div>
              <div v-if=" templateSource!== ''">
                <span style="color: #00469A">模版来源</span>
                <span style="float: right;">{{templateSource}}</span>
                <div style="margin-top: 1rem"><hr style=" height:0.06rem;
    border:0.06rem;
    background-color:#B4B4B4;"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    mounted () {
      // console.log('mounted')
      this.fetchData()
    },
    created () {
    },
    data () {
      return {
//        goodList: []
        workdays: '0',
        templateSource: '',
        productName: ''
      }
    },
    watch: {
      // 如果路由有变化，会再次执行该方法
      // '$route': 'fetchData'
    },
    computed: {
      ...mapState([
        'cartList'
      ]),
      attributeList () {
        let merchandise = this.$route.query.custom
        if (typeof merchandise === 'string') {
          let cartList = this.cartList.cartContent
          for (var i in cartList) {
            if (i === merchandise) {
              this.workdays = cartList[i].workdays
              this.productName = cartList[i].productName
              if (cartList[i].templateSource) {
                this.templateSource = cartList[i].templateSource
              }
              let attr = cartList[i]._attributesList
              for (var j in attr) {
                if (attr[j].columnName === 'GeneInfo' && attr[j].value) {
                  let symbol = attr[j].value.symbol === undefined ? attr[j].value.microNo : attr[j].value.symbol
                  attr[j].value = symbol
                  attr[j].valueText = symbol
                }
              }
              return attr
            }
          }
        } else {
          let res = []
          merchandise.forEach(data => {
            if (data.columnName === 'GeneInfo' && data.value !== undefined) {
              if (JSON.parse(data.value) !== null) {
                let data1 = JSON.parse(data.value)
                console.log(data1)
                let symbol = data1.symbol === undefined ? data1.microNo : data1.symbol
                data.valueText = symbol
              } else {
                data.value = -1
                data.valueText = '-1'
              }
            }
            res.push(data)
          })
          if (this.$route.query.workdays) {
            this.workdays = this.$route.query.workdays
          }
          return res
        }
      }
    },
    methods: {
      fetchData () {
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .gotopay{
    position: absolute;
    right: 0;
    background-color: #00469A;
  @include wh(5rem, 100%);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: -2.5rem;
    width: 5rem;
    height: 3rem;}
  .gotopay_button_style{
  @include sc(.7rem, #F6383A);
    font-weight: bold;
    color: #fff;

  }
  .list-block, .content-block {
    margin: 0.75rem 0;
  }
</style>



// WEBPACK FOOTER //
// CustDetail.vue?8bd1bcba